export default {
  viewBox: "0 0 24 24",
  html: "<path d=\"M21 19H3v2h18zM21 11H3v2h18zM21 3H3v2h18z\"/>"
};